<template>
    <a-modal title="Loading"
             footer="null"
             :loading="isLoading"
             :visible="isVisible">

            <a-card>
                <a-row type="flex" justify="start" class="icons-list">
                    <a-col :flex="2">
                        <a-icon type="clock-circle" />
                    </a-col>
                    <a-col :flex="3" justify="center">
                        <p>Loading data...</p>
                    </a-col> 
                </a-row>

                <a-row type="flex" justify="start" class="icons-list">
                    <a-col :flex="3" justify="center">
                
                </a-col> 
            </a-row>
        </a-card>
             
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            isLoading : false,
            isVisible : false,
        }
    },
    methods : {
        
        showModal () {
            this.isVisible = true;
            this.isLoading = true;
        },
        hideModal () {
            this.isVisible = false;
            this.isLoading = false;
        },

        async sleep(miliSeconds) {
            return new Promise(r => setTimeount(r, miliSeconds));
        }


    }
}
</script>